export default __webpack_public_path__ + "static/media/letterhead_white.30149743.png";